// extracted by mini-css-extract-plugin
var _1 = "EntitySelectCategoryHeading-module__container--dFajE";
export { _1 as "container" }
